// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a625d07e","239":"34d7eed5","453":"14bd990b","732":"dd852c44"}[chunkId] + ".chunk.js";
};